<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal="false"
    title="快速沟通"
    class="rpg-dialog"
  >
    <el-form ref="form" :model="form" label-width="120px" size="mini">
      <el-form-item label="候选人:"> {{ form['候选人'] }} </el-form-item>
      <el-form-item label="推荐顾问:"> {{ form['顾问'] }} </el-form-item>
      <el-form-item label="意愿度" required>
        <el-radio-group v-model="form['意愿度']">
          <div v-for="(v, label) in yis" :key="v.value">
            <el-radio :label="v.value" :title="v.title">{{ label }}</el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="沟通日志">
        <el-input type="textarea" v-model="form['沟通日志']" placeholder="快速填写沟通日志"></el-input>
      </el-form-item>
    </el-form>
    <div class="rpg-dialog-item rpg-text-center">
      <el-button size="mini" type="primary" @click="handleConfirm">提交</el-button>
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      yis: {
        有意愿: { value: 'Y', title: '意向Y' },
        '对本职位无意愿，但有意向换工作': { value: 'NY', title: '意向N，长期意向Y' },
        近期不看机会: { value: 'N', title: '意向N' },
        再跟进: { value: 'F', title: '意向F' },
      },
      rid: '',
      pid: '',
      form: {},
    }
  },
  methods: {
    open(params) {
      const { radish, project } = params
      this.rid = radish.rid || radish._id
      this.pid = project._id
      const form = {
        顾问: app.user.account,
        候选人: radish['姓名'],
      }
      this.form = form
      this.dialogVisible = true
    },
    async handleConfirm() {
      if (!this.form.意愿度) return this.$message('请选择意愿度')
      // 更改意向
      if (this.form.意愿度 == 'NY') {
        const res1 = await app.service('radish').modifyYixiang({ rid: this.rid, pid: this.pid, yixiang: 'N' })
        if (res1.status == 'fail') return this.$message.error(res1.msg)
        const res2 = await app.service('radish').modifyById({ _id: this.rid, data: { 长期意向: 'Y' } })
        if (res2.status == 'fail') return this.$message.error(res2.msg)
      } else {
        const res1 = await app
          .service('radish')
          .modifyYixiang({ rid: this.rid, pid: this.pid, yixiang: this.form.意愿度 })
        if (res1.status == 'fail') return this.$message.error(res1.msg)
      }
      // 增加沟通日志
      if (this.form.沟通日志) {
        const user = app.user.提供者 || app.user.account
        const time = Date.now()
        const answer = {
          remark: [
            {
              stem: '沟通记录',
              answer: this.form.沟通日志,
              time,
              user,
            },
          ],
          radishId: this.rid,
        }
        const res = await app.service('communication').upsert(answer)
        if (res.status == 'fail') return this.$message.error(result.msg)
        app.service('radish').addKpi({
          type: '电话',
          content: { rid: this.rid },
        })
      }
      this.$message.success('操作成功')
      this.onConfirm()
      this.dialogVisible = false
    },
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
